import {useState} from "react";

type GroupItem = {
  name: string;
};

export const useOrganizationFilters = () => {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [selectedGroup, setSelectedGroup] = useState<string>("");
  const [sortColumn, setSortColumn] = useState<string>("");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");

  const handleSort = (column: string) => {
    const newOrder = sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
    setSortColumn(column);
    setSortOrder(newOrder);
  };

  const handleChangeSelectedGroup = (group: GroupItem) => {
    setSelectedGroup(selectedGroup === group.name ? "" : group.name);
  };

  return {
    searchTerm,
    setSearchTerm,
    selectedGroup,
    sortColumn,
    sortOrder,
    handleSort,
    handleChangeSelectedGroup,
  };
};
